<style></style>
<template>
  <div>
    <div class="floated-chat-btn" @click="abrirModalCarrito()" style="z-index: 1000 !important" data-toggle="modal"
      v-if="seleccionada && seleccionada.detalle && !seleccionada.posicion_picking">
      <i class="fas fa-dolly"></i>&nbsp;Asignar Carrito
    </div>
    <div class="content-box">
      <div class="support-index" :class="{ 'show-ticket-content': seleccionada }">
        <div class="support-tickets">
          <div class="support-tickets-header">
            <div class="tickets-control">
              <div class="row">
                &nbsp;&nbsp;&nbsp;
                <div class="col-12">
                  <h6>Picking Despachos</h6>
                </div>
                <div class="col-6">
                  <span class="font-weight-bold text-dark text-center">Ver Picking Finalizados: &nbsp;</span><label
                    class="switch"><input @change="VerFinalizados()" type="checkbox" v-model="estado"
                      class="text-center" /><span class="slider-button"></span></label>
                </div>
                <br />
                <div class="col-6">
                  <button data-toggle="modal" data-target="#modalFiltros" class="btn btn-sm btn-success">
                    Búsqueda Avanzada <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="tickets-filter">
              <div class="row col-12">
                <div class="col-5">
                  <button type="button" data-toggle="modal" data-target="#modalCrearTarea"
                    class="btn btn-primary btn-block">
                    Nueva Tarea <i class="fa fa-plus"></i>
                  </button>
                </div>
                <div class="col-7">
                  <button type="button" class="btn btn-info btn-block" @click="verInventarioDeEstacion()">
                    Inventario Posición
                    <i class="fas fa-pallet"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <DespachoTicketComponent v-for="item in despachos.results" :key="item.id" :despachoe="item"
              @seleccion="seleccionar" />
            <PaginationComponent tipo="MINI" :currentPage="currentPage" :data="despachos" @pagechanged="onPageChange" />
          </div>
        </div>
        <div class="support-ticket-content-w" style="background-color: rgb(249, 249, 249);">
          <div class="support-ticket-content" style="background-color: rgb(249, 249, 249);">
            <div class="support-ticket-content-header mb-0" v-if="seleccionada" style="display: block">
              <br />
              <a class="back-to-index" href="#" @click="ResetSelect()">
                <i class="os-icon os-icon-arrow-left5"></i>
                <span style="color:#71bf44;">Atrás</span>
              </a>
              <div style="text-align: center;">
                <span class="ticket-header" style="font-size: 18px"><b>Tarea Picking</b></span>
                <br />
                <b>Orden de Despacho #{{ seleccionada.numero }}</b>
                <br />
                <br />
                <span v-if="seleccionada" class="badge" v-bind:class="{
                  'badge-danger': seleccionada.estado == '9',
                  'badge-success': seleccionada.estado == 'A',
                  'badge-info': seleccionada.estado == 'B',
                  'badge-dark': seleccionada.estado == 'C',
                }">{{ seleccionada.estado_str }}</span>
              </div>
              <div>
                <br />
                Tienda:
                {{ seleccionada.tienda.nombre }}
                ({{ seleccionada.tienda.codigo }})

                <br />
                F/H:
                {{ seleccionada.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss a") }}
                <br />
                Ruta: #{{ seleccionada.ruta_despacho }}
              </div>
              <br>
              <button @click="refreshCurrent()" class="btn btn-sm btn-info">
                Actualizar Info. <i class="fas fa-sync"></i>
              </button>
              <ModalPickearComponent :despachoe="seleccionada" @refreshCurrent="seleccionar(seleccionada.id)"
                v-if="seleccionada.posicion_picking" />
              <!-- Boton de acciones flotantes start  -->
              <div class="fab">
                <div @click="abrirModalOpciones()" class="btn-round">
                  <i id="addIcon"><i class="fas fa-bars"></i></i>
                </div>
              </div>
              <!-- Boton de acciones flotantes END  -->
              <br />
              <br />
            </div>
            <hr>
            <div v-if="seleccionada">
              <span class="ticket-header" style="font-size: 18px">Detalle de Picking</span>
              <hr>
              <ModalDividirPickingComponent @refreshCurrent="refreshAll()" :categoriasPicking="categoriasPicking"
                :despachoe="seleccionada" />
            </div>
            <DespachoDetalleComponent :despachoe="seleccionada" @seleccion="seleccionar" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalFiltros" index="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Búsqueda por Filtros</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="row">
                <button v-on:click="clearFilterData()" type="button" class="btn btn-link">
                  Refresh &nbsp; <i class="fa fa-sync"></i>
                </button>
              </div>
              <div class="row">
                <div class="col-12" style="padding: 3px">
                  <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                    type="text" />
                </div>
                <div style="padding: 3px" class="col-12">
                  <input class="form-control form-control-sm rounded bright" placeholder="#" v-model="search.numero"
                    type="text" />
                </div>
                <div style="padding: 3px" class="col-12">
                  <select class="form-control form-control-sm rounded bright" v-model="filtro_tienda">
                    <option value="">Tienda</option>
                    <option v-for="data in tiendas" :value="data.codigo" v-bind:key="data.id">
                      {{ data.nombre }}
                    </option>
                  </select>
                </div>
                <div style="padding: 3px" class="col-12">
                  <input type="date" v-model="search.fecha" class="form-control form-control-sm rounded bright" />
                </div>

                <div style="padding: 3px" class="col-12">
                  <select :disabled="!filtro_tienda" class="form-control form-control-sm rounded bright"
                    v-model="filtro_caja">
                    <option value="">cajas</option>
                    <option v-for="data in cajas" :value="data.id" v-bind:key="data.id">
                      {{ data.caja }}
                    </option>
                  </select>
                </div>

                <div style="padding: 3px" class="col-12">
                  <select class="form-control form-control-sm rounded bright" v-model="filtro_estado">
                    <option value>ESTATUS</option>
                    <option value="9">ANULADO</option>
                    <option value="A">ABIERTO</option>
                    <option value="B">PICKING_FINALIZADO</option>
                    <option value="C">CERRADO</option>
                    <option value="Z">FINALIZADO</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="filterData()" type="button" class="btn btn-lg btn-success">
              <i class="fa fa-search"></i>
            </button>
            <button @click="clearFilterData()" type="button" class="btn btn-lg btn-dark">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAggCarrito" index="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Asignar Carrito</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input v-on:keyup.enter="asignarCarrito()" focus type="text" class="form-control" v-model="barra"
              ref="carritox" />
            <small class="text-danger" v-if="errors && errors.barra">{{
              errors.barra[0]
            }}</small>
          </div>
          <div class="modal-footer">
            <button @click="asignarCarrito()" type="button" class="btn btn-lg btn-block btn-success">
              <i class="fa fa-dolly"></i> Asignar Carrito
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalEstacionarProducto" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Estacionar producto</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input type="text" v-on:keyup.enter="estacionarProducto()" class="form-control" v-model="barra" />
            <small class="text-danger" v-if="errors && errors.barra">{{
              errors.barra[0]
            }}</small>
          </div>
          <div class="modal-footer">
            <button @click="estacionarProducto()" type="button" class="btn btn-lg btn-block btn-outline-success">
              <i class="fas fa-pallet"></i> Estacionar Producto
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalCrearTarea" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Crear tarea de pedido</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <label v-if="current.scan_barra == true">Barra de pedido</label>
              <label v-if="current.scan_barra == false"># de pedido</label>
              <input ref="pedidox" type="text" v-on:keyup.enter="crearTarea()" class="form-control"
                v-model="current.barra" />
              <small class="text-danger" v-if="errors && errors.barra">{{
                errors.barra[0]
              }}</small>
            </div>
            <br />
            <div v-if="current.scan_barra == false" class="col-12">
              <TiendaSelectComponent titulo="Seleccionar una tienda" :current="current" />
            </div>
            <div v-if="current.scan_barra == false && current.tienda" class="col-12">
              <CajaSelectComponent :tienda="current.tienda" :current="current" />
            </div>
            <br />

            <div class="col-12">
              <button @click="crearTarea()" type="button" class="btn btn-success btn-md btn-block">
                Aceptar
                <i class="fas fa-check"></i>
              </button>
              <br />
            </div>

            <button @click="cambiarTipoScan()" class="btn btn-dark btn-md btn-block" v-if="current.scan_barra == false">
              Buscar por # barra
            </button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalOpciones" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button class="btn btn btn-block btn-danger" style="margin-top: 0.14rem; padding: 0.4rem" :disabled="!(
              seleccionada &&
              seleccionada.estado == 'A' &&
              seleccionada.posicion_picking &&
              seleccionada.detalle[0]
            )
              " type="button" @click="finalizarPicking()">
              <div class="activity-avatar">
                <i class="fa fa-lock fa-1x"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Finalizar Picking</span>
              </div>
            </button>
            <hr />
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem" v-if="seleccionada"
              :disabled="seleccionada.estado == 'A'" @click="reabrirPicking()" type="button">
              <div class="activity-avatar">
                <i class="fas fa-lock-open"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Abrir</span>
              </div>
            </button>
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="!(seleccionada && seleccionada.posicion_picking == null)" @click="abrirDividirPicking()"
              type="button">
              <div class="activity-avatar">
                <i class="far fa-clone"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Dividir Picking</span>
              </div>
            </button>
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="!(seleccionada && seleccionada.posicion_picking == null)" @click="cambiarUsuarioPicking()"
              type="button">
              <div class="activity-avatar">
                <i class="fas fa-edit"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Cambiar Usuario Picking</span>
              </div>
            </button>
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              @click="reimprimir_pedido()" type="button">
              <div class="activity-avatar">
                <i class="fas fa-print"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Reimprimir Pedido</span>
              </div>
            </button>
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              @click="verInventarioDeEstacion()">
              <div class="activity-info">
                <span class="font-weight-bold">Inventario en posición<br />
                  <i class="fas fa-boxes"></i></span>
              </div>
            </button>
            <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              @click="estacionProducto()" type="button" :disabled="!(
                seleccionada &&
                seleccionada.estado == 'A' &&
                seleccionada.posicion_picking &&
                seleccionada.detalle[0]
              )
                ">
              <div class="activity-avatar">
                <i class="fas fa-pallet"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Estacionar Producto</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ExistenciasModalComponent :existencias="existencias" />
  </div>
</template>
<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import DynamicService from "@/services/commons/DynamicService";
import DespachoTicketComponent from "@/components/wms/despachos/DespachoTicketComponent";
import DespachoDetalleComponent from "@/components/wms/despachos/DespachoDetalleComponent";
import ModalPickearComponent from "@/components/wms/despachos/ModalPickearComponent";
import ModalDividirPickingComponent from "@/components/wms/despachos/ModalDividirPickingComponent";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CajaSelectComponent from "@/components/commons/CajaSelectComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    DespachoTicketComponent,
    DespachoDetalleComponent,
    ModalPickearComponent,
    TiendaSelectComponent,
    ModalDividirPickingComponent,
    CajaSelectComponent,
    ExistenciasModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      currentPage: 1,
      searchtext: "",
      filtro_tienda: "",
      filterActivo: "",
      tiendas: "",
      filtro_caja: "",
      filtro_estado: "A",
      cajas: "",
      search: {},
      existencias: [],
      estado: false,
      estado_: "A",
      categoriasPicking: [],
      barra: "",
      errors: {
        barra: null,
        cantidad: null,
      },
      tipo: "FACTURAS",
      seleccionada: null,
      despachos: [],
      nueva_etiqueta: {
        cantidad: 1,
      },
      id_factura_editar: null,
      filter_estado: "",
      current: {
        scan_barra: true,
        id: null,
        estado_str: null,
        estado: "A",
        errors: [],
        bultoe_set: [],
        facturae_set: [],
        recepcionetiqueta_set: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    this.refreshTienda();
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[carritox]').focus();
      self.$refs.carritox.focus();
      self.$refs.pedidox.focus();
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    self.refreshCurrent();
    if (this.$route.params.id) {
      this.refreshDespachoE();
    }
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshCurrent({
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        caja: this.filtro_caja,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    verInventarioDeEstacion() {
      $("#modalOpciones").modal("hide");
      $("#modalBarraPosicion").modal("show");
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        activa: true,
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    filterData() {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.refreshCurrent({
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        caja: this.filtro_caja,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    refreshCurrent(params) {
      let self = this;
      if (!params) {
        params = { estado: "A" };
      }
      DynamicService.fetch("wms", "picking-despacho", params).then((response) => {
        self.despachos = response.data;
        $("#modalFiltros").modal("hide");
      });
    },
    reimprimir_pedido() {
      let self = this;
      $("#modalOpciones").modal("hide");
      let pedido_e = self.seleccionada.pedido_e.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Tarea_Procter.jrxml&id=${pedido_e}`
      );
    },
    reabrirPicking() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Abrir picking nuevamente",
        "¿Esta seguro?",
        "Yes",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "abrir_picking"
          )
            .then((response) => {
              Notifications.alert.success("Abrir picking", "Realizado correctamente");
              self.seleccionar(self.seleccionada.id);
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error("Abrir picking", error.response.data.detail);
              }
            });
        }
      );
    },
    VerFinalizados() {
      if (this.estado == true) {
        this.refreshCurrent({ estado: "B" });
      }
      if (this.estado == false) {
        this.refreshCurrent({ estado: "A" });
      }
    },
    abrirModalOpciones() {
      $("#modalOpciones").modal("show");
    },
    RefreshCategoriasPicking() {
      DynamicService.getAction(
        "wms",
        "picking-despacho",
        this.seleccionada.id,
        "productos_por_categorias"
      ).then((response) => {
        this.categoriasPicking = response.data;
      });
    },
    abrirModalCarrito() {
      $("#modalOpciones").modal("hide");
      $("#modalAggCarrito").modal("show");
    },
    abrirDividirPicking() {
      $("#modalOpciones").modal("hide");
      $("#dividirPickingModal").modal("show");
    },
    cambiarUsuarioPicking() {
      $("#modalOpciones").modal("hide");
      $("#cambiarUsuarioPicking").modal("show");
    },
    estacionProducto() {
      let self = this;
      $("#modalOpciones").modal("hide");
      $("#modalEstacionarProducto").modal("show", function () {
        self.$refs.carritox.focus();
      });
    },
    finalizarPicking() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Finalizar picking",
        "¿Esta Seguro(a)?",
        "oki",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "finalizar_picking"
          )
            .then((response) => {
              Notifications.alert.success(
                "Finalizar picking",
                "Producto estacionado correctamente"
              );
              self.seleccionar(self.seleccionada.id);
              self.cleanErrors();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Finalizar picking",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    cambiarTipoScan() {
      if (this.current.scan_barra == true) {
        this.current.scan_barra = false;
      } else {
        this.current.scan_barra = true;
      }
    },
    ResetSelect() {
      this.$router.push({ path: `/wms/despachos/` });
      this.seleccionada = null;
    },
    crearTarea() {
      let self = this;
      DynamicService.postActionList(
        "wms",
        "picking-despacho",
        "crear_tarea",
        this.current
      )
        .then((response) => {
          Notifications.alert.success("Crear tarea", "Crear tarea correctamente");
          $("#modalCrearTarea").modal("hide");
          self.barra = "";
          self.refreshAll();
          self.cleanErrors();
        })
        .catch((error) => {
          delete this.current.barra;
          delete this.current.tienda;
          self.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error("Crear tarea", error.response.data.detail);
          }
        });
    },
    cleanErrors() {
      let self = this;
      this.current.errors.barra = "";
      this.errors.barra = "";
    },
    asignarCarrito() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar carrito",
        "¿Esta Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "asignar_carrito",
            {
              barra: self.barra,
              tienda: self.seleccionada.tienda.codigo,
            }
          )
            .then((response) => {
              self.cleanErrors();
              Notifications.alert.success(
                "Asignar carrito",
                "Asignar carrito correctamente"
              );
              $("#modalAggCarrito").modal("hide");
              self.seleccionar(self.seleccionada.id);
              self.barra = "";
              self.cleanErrors();
            })
            .catch((error) => {
              self.barra = "";
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error("Asignar carrito", error.response.data.detail);
              }
            });
        }
      );
    },
    estacionarProducto() {
      let self = this;
      Notifications.alert.confirm(
        "Estacionar producto de carrito",
        "¿Esta Seguro(a)?",
        "oki",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "asignar_a_estacion",
            {
              barra: self.barra,
              tienda: self.seleccionada.tienda.codigo,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Estacionar producto de carrito",
                "Producto estacionado correctamente"
              );
              $("#modalEstacionarProducto").modal("hide");
              self.seleccionar(self.seleccionada.id);
              self.barra = "";
              self.cleanErrors();
            })
            .catch((error) => {
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Estacionar producto del carrito",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    clearFilterData() {
      this.refreshCurrent({
        page: 1,
        "filter[search]": "",
        estado: "A",
        caja: "",
        tienda: "",
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      });
    },
    refreshDespachoE() {
      let self = this;
      DynamicService.getById("wms", "picking-despacho", this.$route.params.id).then(
        (response) => {
          self.seleccionada = response.data;
          this.RefreshCategoriasPicking();
        }
      );
    },
    refreshAll() {
      this.refreshCurrent();
      this.refreshDespachoE(this.seleccionada.id);
      this.cleanErrors();
    },
    deseleccionar() {
      this.seleccionada = null;
      this.refreshCurrent();
      this.cleanErrors();
    },
    seleccionar(despachoe_id) {
      this.$router.push({ path: `/wms/despachos/${despachoe_id}/` });
      this.refreshDespachoE();
    },
  },
};
</script>
